export default [
  { value: 'Gasolina', text: 'Gasolina' },
  { value: 'Diesel', text: 'Diesel' },
  { value: 'Flex', text: 'Flex' },
  { value: 'Etanol', text: 'Etanol' },
  { value: 'Gás Natural Veicular', text: 'Gás Natural Veicular' },
  { value: 'Híbrido', text: 'Híbrido' },
  { value: 'Elétrico', text: 'Elétrico' },
];
